import { NEWSROOMS_BASE_URL } from '@/utils/enums';
import { mapElements } from '@/utils/helpers/object';
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';

export const useInstantSearch = () => {
  const { t } = useI18n();
  const paginationTotalHits = ref(1000);
  const instantMeili = ref(
    instantMeiliSearch(process.env.APP_MEILISEARCH_HOST, process.env.APP_MEILISEARCH_API_KEY, {
      keepZeroFacets: false,
      finitePagination: true
    })
  );
  const searchClient = computed(() => instantMeili.value.searchClient);
  const transformItems = items =>
    items.map(item => ({
      ...mapElements(item, NEWSROOMS_BASE_URL.replace('/', '')),
      _highlightResult: {
        ...item._highlightResult
      }
    }));
  const createFacetFilters = (filterName, filters) => {
    let result = [];
    if (typeof filters === 'string') {
      result = [`${filterName}:${filters}`];
    } else if (Array.isArray(filters)) {
      const customFilters = [];
      filters.forEach(facet => {
        customFilters.push(`${filterName}:${facet}`);
      });
      result.push(customFilters);
    }
    return result;
  };
  const createFilters = (filterName, values, operator = ':', booleanOperator) => {
    let result = '';
    values.forEach((value, index) => {
      result += `${filterName} ${operator} ${value}${
        index < values.length - 1 ? ` ${booleanOperator} ` : ''
      }`;
    });
    return result;
  };
  const createHitsPerPage = (values, valueDefault) =>
    values.map(value => ({
      label: t('ui.label.aisHitsPerPage', { value }),
      value,
      default: value === valueDefault
    }));

  const changePaginationTotalHits = num => (paginationTotalHits.value = num);

  const createRefinementListParameters = (facetName, facetValue) => {
    const refinement = {};
    refinement[facetName] =
      typeof facetValue === 'string'
        ? [facetValue.replaceAll('<em>', '').replaceAll('</em>', '')]
        : Array.isArray(facetValue)
          ? facetValue
          : [];
    return refinement;
  };

  const createSearchQueryParameters = (indexUi, query, filters) => {
    const uiState = {};
    uiState[indexUi] = {};
    if (query) uiState[indexUi].query = query;
    if (filters) uiState[indexUi].refinementList = filters;
    const { search } = new URL(historyRouter().createURL(uiState));
    return decodeURIComponent(search.replace(/%20/g, '+'));
  };

  return {
    instantMeili,
    searchClient,
    createFilters,
    transformItems,
    createHitsPerPage,
    createFacetFilters,
    paginationTotalHits,
    changePaginationTotalHits,
    createSearchQueryParameters,
    createRefinementListParameters
  };
};
